import { render, staticRenderFns } from "./ZohoLeads.vue?vue&type=template&id=b71f65a0&scoped=true&"
import script from "./ZohoLeads.vue?vue&type=script&lang=js&"
export * from "./ZohoLeads.vue?vue&type=script&lang=js&"
import style0 from "./ZohoLeads.vue?vue&type=style&index=0&id=b71f65a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71f65a0",
  null
  
)

export default component.exports